// @flow
import React, { type Node } from 'react';

import useStatementsData from './useStatementsData';
import StatementsContext from './StatementsContext';


type Props = {
  children: Node,
}

const StatementsData = ({ children }: Props) => {
  const data = useStatementsData();

  return (
    <StatementsContext.Provider value={data}>
      {children}
    </StatementsContext.Provider>
  );
};

export default StatementsData;
